import { WbGrid, WbGridCol, WbGridRow } from '@workbench/react';
import ImageCard from './ImageCard';

const COL_SPAN = { 1: 12, 2: 6, 3: 4, 4: 3, 6: 2 };

function ImageRenderItem({ vin, imageList, imageType, background, rowCount, isDownload }) {
	const error = imageList.find((image) => 'errorMessage' in image);
	if (error) {
		return <div>{error.errorMessage}</div>;
	}

	const span = COL_SPAN[rowCount] || 2;

	return (
		<WbGrid fullWidth>
			<WbGridRow>
				{imageList.map(({ url, title, imageId }) => (
					<WbGridCol key={imageId || title} mq1={12} mq3={6} mq5={span}>
						<ImageCard
							vin={vin}
							imageId={imageId}
							url={url}
							title={title}
							imageType={imageType}
							background={background}
							isDownload={isDownload}
						/>
					</WbGridCol>
				))}
			</WbGridRow>
		</WbGrid>
	);
}

export default ImageRenderItem;
